import { RatePosition } from "../types";

interface PositionBadgeProps {
  position: RatePosition | null;
  percent: number | null;
  isExclusive?: boolean;
}

export default function PositionBadge({ position, percent, isExclusive }: PositionBadgeProps) {
  if (isExclusive) {
    return (
      <span className="inline-flex items-center rounded-full bg-[#EFF6FF] px-[10px] py-[4px] text-[12px] font-medium text-[#2563EB]">
        Exclusive
      </span>
    );
  }

  if (position === "leading") {
    return (
      <span className="inline-flex items-center rounded-full bg-[#F4EDFB] px-[10px] py-[4px] text-[12px] font-medium text-[#734792]">
        Leading
      </span>
    );
  }

  if (position === "behind") {
    return (
      <span className="inline-flex items-center rounded-full bg-[#FEF3E7] px-[10px] py-[4px] text-[12px] font-medium text-[#C2650A]">
        Behind {percent ?? 0}%
      </span>
    );
  }

  return (
    <span className="inline-flex items-center rounded-full bg-[#F4F4F5] px-[10px] py-[4px] text-[12px] font-medium text-[#71717A]">
      No data
    </span>
  );
}
